import(/* webpackMode: "eager" */ "/app/src/app/cookies/layout.tsx");
